import { Button, Card, Container, Tab, Table, Tabs } from "react-bootstrap";
import Banner from "../components/Banner";
import BreadcrumbBar from "../components/Breadcrumb";

export default function Help() {
  return (
    <>
      <Banner
        heading="Help"
        description="Welcome to the Help Center. Here you’ll find answers to common questions about using the community, managing your account, and subscription details."
      />
      <BreadcrumbBar
        items={[{ label: "Home", href: "/" }, { label: "Help" }]}
      />
      <Container>
        <div className="profile-outer-box">
          <div className="profile-content help">
            <div className="help-card">
              <h3>Getting Started</h3>
              <div className="help-card-item">
                <p className="question">Who can join the community?</p>
                <p className="answer">
                  Anyone can explore public content, but only paid members can
                  start or reply to discussions.
                </p>
              </div>
              <div className="help-card-item">
                <p className="question">How do I create a new discussion?</p>
                <p className="answer">
                  Go to the Community Hub, click Start New Discussion, add your
                  title, body, and tags, then post.
                </p>
              </div>
              <div className="help-card-item">
                <p className="question">What topics can I discuss?</p>
                <p className="answer">
                  We currently support categories like Cancer, Mental Health,
                  Nutrition, and more. Please follow our [Community Guidelines].
                </p>
              </div>
            </div>
            <div className="help-card">
              <h3>Managing Your Account</h3>
              <div className="help-card-item">
                <p className="question">How do I update my profile?</p>
                <p className="answer">
                  Open your profile, click Edit Profile, and update your
                  details, interests, or avatar.
                </p>
              </div>
              <div className="help-card-item">
                <p className="question">Can I remain anonymous?</p>
                <p className="answer">
                  Yes, you can use a display handle instead of your full name.
                </p>
              </div>
            </div>
            <div className="help-card">
              <h3>Subscription & Billing</h3>
              <div className="help-card-item">
                <p className="question">How do I upgrade my plan?</p>
                <p className="answer">
                  Visit the Pricing Page and select the plan that fits you best.
                </p>
              </div>
              <div className="help-card-item">
                <p className="question">How do I cancel my subscription?</p>
                <p className="answer">
                  Go to Account Settings {">"} Subscription {">"} Cancel
                  Subscription. You’ll retain premium access until the end of
                  your billing cycle. After cancellation, your account reverts
                  to free access.
                </p>
              </div>
            </div>
            <div className="help-card">
              <h3 className="heading-with-button">
                Subscription & Billing{" "}
                <Button variant="outline-secondary">
                  Read Community Guidelines
                </Button>
              </h3>
              <div className="help-card-item">
                <p className="answer">
                  <ul>
                    <li>Be respectful and supportive.</li>
                    <li>
                      No spam, harmful content, or medical misinformation.
                    </li>
                    <li>
                      Report inappropriate posts using the Report button in any
                      discussion.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="support">
              If you can’t find what you’re looking for, contact our support
              team at{" "}
              <a href="mailto:support@healthscopeai.com">
                support@healthscopeai.com
              </a>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
